import React from 'react'

import Contact from './Contact'
import {Button, TextField} from '@material-ui/core/'
import {canPostMessageToMobile, isAndroid, isIOS, Message, postMessageToMobile} from "../Helpers/clientCommunication";
import {getCookie} from "../Helpers/cookies";
import {getAreaCode} from "../Helpers/phoneNumber";

class Contacts extends React.Component {

  constructor(props) {
    super(props);

    // DO NOT REMOVE
    // The following line is important because it allows the mobile apps to access this component and call its functions
    window.invitesComponent = this

    this.state = {
      isEnabled: true,
      contacts: undefined, // Contact data as received from mobile
      filteredContacts: undefined, // Contact data filtered to only include valid contacts
      contactSearchText: '',
      contactSearchResults: undefined
    }
  }

  getPhoneContacts() {
    // Tell the mobile app to send us contacts
    const device = this.props.device
    const version = this.props.version
    console.log("getPhoneContacts: device=[" + device + "], version=[" + version + "]")
    if (canPostMessageToMobile(device, version)) {
      const message = new Message(Message.ACTION_GET_CONTACT_LIST, {})
      postMessageToMobile(device, version, message)
    } else {
      console.log("getPhoneContacts: Mobile app doesn't support messaging, showing update message")
      this.setState((state, props) => ({
          isEnabled: false
        }
      ))
    }
  }

  // This function is called by the mobile app to deliver the device's contacts
  mobileAppDidSendContacts = contactData => {
    // TESTING
    // console.log("Contacts mobileAppDidSendContacts using test data")
    // const sampleData = {
    //   aid: '38f95f80-ff29-4200-a0b0-89c1019aef4a',
    //   did: 'f507c53a-fb9b-404c-9230-4d84a5f88078',
    //   pid: 'and',
    //   contacts: [
    //     {
    //       first_name: 'Mike',
    //       last_name: 'Ebert',
    //       phone_numbers: [{ number: '208-710-6377' }],
    //       email_addresses: [
    //         { address: 'michael.k.ebert@gmail.com', type: 'OTHER' },
    //         { address: 'mike@quatetra.com', type: 'WORK' }
    //       ]
    //     },
    //     {
    //       email_addresses: [],
    //       phone_numbers: [
    //         { type: 'OTHER', number: '(801) 444-6566' },
    //         { type: 'WORK', number: '+1 800-444-2777' }
    //       ]
    //     },
    //     {
    //       last_name: 'Oaks',
    //       first_name: 'Dan',
    //       email_addresses: [],
    //       phone_numbers: [
    //         { type: 'MOBILE', number: '(801) 123-9197' },
    //         { type: 'HOME', number: '(801) 123-4276' }
    //       ]
    //     },
    //     {
    //       first_name: 'John',
    //       last_name: 'Doe',
    //       phone_numbers: [],
    //       email_addresses: []
    //     },
    //     {
    //       first_name: 'Tyler',
    //       last_name: 'Wood',
    //       phone_numbers: [],
    //       email_addresses: [{ address: 'tylerwood@testmail.com', type: 'WORK' }]
    //     }
    //   ]
    // }
    // const contacts = sampleData['contacts']
    // this.setState((state, props) => ({
    //   contacts: contacts
    // }))
    // this.filterContacts(contacts)

    // PROD
    if (contactData !== undefined && contactData['contacts'] !== undefined) {
      const contacts = contactData['contacts']
      this.setState((state, props) => ({
        contacts: contactData['contacts']
      }))
      this.filterContacts(contacts)
    } else {
      console.warn("mobileAppDidSendContacts: No valid contacts")
    }
  }

  filterContacts(contacts) {
    console.log("Contacts filterContacts")
    const friends = this.props.friends
    let filteredItems = undefined
    if (contacts !== undefined && contacts.length > 0) {
      filteredItems = contacts

      // First thing, we need to filter out contacts without a first name
      filteredItems = filteredItems.filter(
          item => item['first_name'] !== undefined && item['first_name'] !== ''
      )

      // Now filter out contacts who are already in the user's list of friends
      filteredItems = filteredItems.filter(item => {
        for (let i = 0; i < friends.length; i++) {
          // Check this friend's email against the contact's list of emails
          if (
              friends[i].emailAddress !== undefined &&
              friends[i].emailAddress !== ''
          ) {
            let emails = item['email_addresses']
            emails = emails.filter(
                email => email['address'] === friends[i].emailAddress
            )
            if (emails.length > 0) {
              return false
            }
          }
          // Check this friend's phone number against the contact's list of phone numbers
          if (
              friends[i].phoneNumber !== undefined &&
              friends[i].phoneNumber !== ''
          ) {
            let numbers = item['phone_numbers']
            numbers = numbers.filter(
                number =>
                    number['number'].replace(/[^\w]|/g, '') ===
                    friends[i].phoneNumber.replace(/[^\w]|/g, '')
            )
            if (numbers.length > 0) {
              return false
            }
          }
        }
        return true // If we haven't matched anything by this point, then this contact hasn't matched anyone in the friends list and can stay to be displayed and invited
      })
    }

    // Add a full_name property to each contact to make searches easier
    if (filteredItems !== undefined && filteredItems.length > 0) {
      filteredItems = filteredItems.map((item, i) => {
        const firstName = item.first_name
        const lastName = item.last_name
        const fullName = firstName + " " + lastName
        item.full_name = fullName
        return (item)
      })
    }

    filteredItems = this.sortContacts(filteredItems)

    this.setState((state, props) => ({
      filteredContacts: filteredItems
    }))
  }

  sortContacts(contacts) {
    // We sort contacts in the following order:
    // 1) Those who have emoji in their name. Young people usually do this for close friends.
    // 2) Those whose last name matches this user's last name. Family
    // 3) Those whose phone number area code matches the current user's area code. These are people who are nearby.
    // 4) NOT IMPLEMENTED: Those whose phone number area code is nearby to the current user's area code.
    // 5) All others
    // Each set of matches is alphabetically sorted and then recompiled into a single list.
    console.log("sortContacts");

    // Get the current user's last name
    const userDisplayName = getCookie("userNameDisplay")
    const userDisplayNameSplit = userDisplayName.split(" ")
    const userLastName = userDisplayNameSplit[userDisplayNameSplit.length - 1]

    // Get the current user's phone number
    const userPhoneNumber = getCookie("userPhoneNumber")
    const userAreaCode = getAreaCode(userPhoneNumber)

    // Debug logging
    // console.log("sortContacts: userLastName=[" + userLastName + "]")
    // console.log("sortContacts: userPhoneNumber=[" + userPhoneNumber + "]")
    // console.log("sortContacts: userAreaCode=[" + userAreaCode + "]")

    let emojiMatches = []
    let lastNameMatches = []
    let areaCodeMatches = []
    let nearbyAreaCodeMatches = []
    let other = []
    for (let i = 0; i < contacts.length; i++) {
      const contact = contacts[i]

      // Check for emoji in first or last name
      const fullName = contact.full_name
      const containsEmoji = window["containsEmoji"](fullName)
      if (containsEmoji) {
        emojiMatches.push(contact)
        continue
      }

      // Check for last name match
      const lastName = contact.last_name
      if (lastName && (lastName.toLowerCase() === userLastName.toLowerCase())) {
        lastNameMatches.push(contact)
        continue
      }

      // Do phone number matching if current user has a phone number with a valid area code
      if (userAreaCode) {
        const phoneNumbers = contact.phone_numbers
        // console.log("sortContacts: contact fullName=[" + fullName + "], phoneNumbers=[" + JSON.stringify(phoneNumbers) + "]")
        if (phoneNumbers !== undefined && phoneNumbers.length > 0) {
          // If at least one of the phone numbers matches, then we add the contact to the matches and continue to the
          // next loop cycle
          let phoneNumberMatched = false
          for (let j = 0; j < phoneNumbers.length; j++) {
            const phoneNumber = phoneNumbers[j].number

            // Check for area code match
            const areaCode = getAreaCode(phoneNumber)
            if (areaCode === userAreaCode) {
              areaCodeMatches.push(contact)
              phoneNumberMatched = true
              break
            }

            // TODO: Check for nearby area code match

          }
          if (phoneNumberMatched) {
            continue
          }
        }
      }

      // Other contacts are those which did not match above
      other.push(contact)
    }

    console.log("sortContacts: emojiMatches [" + emojiMatches.length + "]")
    console.log("sortContacts: lastNameMatches [" + lastNameMatches.length + "]")
    console.log("sortContacts: areaCodeMatches [" + areaCodeMatches.length + "]")
    console.log("sortContacts: nearbyAreaCodeMatches [" + nearbyAreaCodeMatches.length + "]")
    console.log("sortContacts: other [" + other.length + "]")

    // Alphabetically sort each list of matches
    this.sortContactsAlphabetically(emojiMatches)
    this.sortContactsAlphabetically(lastNameMatches)
    this.sortContactsAlphabetically(areaCodeMatches)
    this.sortContactsAlphabetically(nearbyAreaCodeMatches)
    this.sortContactsAlphabetically(other)

    // Concat each list of matches into a single list
    let sortedContacts =
      emojiMatches
        .concat(lastNameMatches)
        .concat(areaCodeMatches)
        .concat(nearbyAreaCodeMatches)
        .concat(other)

    console.log("sortContacts: Total sorted contacts [" + sortedContacts.length + "]")

    return sortedContacts
  }

  sortContactsAlphabetically(contacts) {
    contacts.sort((a, b) => a.first_name.localeCompare(b.first_name))
    if (contacts.length > 1) {
      contacts.sort((a, b) => {
        if (
          a['first_name'].toString().toLowerCase() ===
          b['first_name'].toString().toLowerCase()
        ) {
          return 0
        } else if (
          a['first_name'].toString().toLowerCase() >
          b['first_name'].toString().toLowerCase()
        ) {
          return 1
        } else if (
          a['first_name'].toString().toLowerCase() <
          b['first_name'].toString().toLowerCase()
        ) {
          return -1
        } else return 0 // Our function is confused if it gets here...
      })
    }
  }

  searchFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    if (name === "contactSearchText" && this.state.isEnabled) {
      this.searchFormSubmit(value)
    }

    this.setState({
      [name]: value
    })
  }

  searchFormSubmit = (searchText) => {
    console.log("Contacts searchFormSubmit: [" + searchText + "]")

    if (!searchText) {
      this.clearSearch()
      return
    }

    let contacts = this.state.filteredContacts
    const searchResults = contacts.filter(contact => {
      return contact.full_name.toLowerCase().includes(searchText.toLowerCase())
    })
    console.log("Contacts searchFormSubmit number of search results: [" + searchResults.length + "]")

    this.setState((state, props) => ({
      contactSearchResults: searchResults
    }))
  }

  clearSearch = () => {
    this.setState((state, props) => ({
      contactSearchResults: undefined
    }))
  }

  componentDidMount() {
    const contacts = this.state.filteredContacts
    let numContacts = undefined
    if (contacts) {
      numContacts = contacts.length
    }
    console.log("Contacts componentDidMount: Existing contacts [" + numContacts + "]")

    this.getPhoneContacts()
  }

  render() {
    let isEnabled = this.state.isEnabled
    let contacts = this.state.filteredContacts
    let searchResults = this.state.contactSearchResults

    let content = ''
    if (isEnabled) {
      if (searchResults !== undefined) {
        if (searchResults.length === 0) {
          // Show no results message
          // content = (<p className={"text-center"}>No Search Results</p>)
          content = (
            <div>
              {this.SearchBar()}
              {this.Message("No Search Results")}
            </div>
          )
        } else {
          // We have search results, display them
          content = this.ContactContent(searchResults)
        }
      } else {
        // There is no active search, display all contacts
        if (contacts !== undefined && contacts.length > 0) {
          content = this.ContactContent(contacts)
        } else {
          // There are no contacts, show message
          // content = (<p className={"text-center"}>No Contacts</p>)
          content = this.Message("No Contacts Found")
        }
      }
    } else {
      // Mobile app doesn't support contact functionality, show an update prompt
      const device = window.queryParams.device
      if (isIOS(device)) {
        content = this.Message("Please update Cook'n to version 25.6.0 or later to use this feature.")
      } else if (isAndroid(device)) {
        content = this.Message("Please update Cook'n to version 5.0.7 or later to use this feature.")
      } else {
        // This is an error because the Contacts.js component should only be loaded when device is "ios" or "and"
        content = this.Message("This feature is not available on this platform.")
      }
    }

    return (
      <div>
        <div className={"text-center"}>
          <h2>Invite Your Phone Contacts</h2>
          <p>
            This feature allows you to connect with your Phone Contacts.
            <br />
            Simply allow Cook'n to access your contacts and then click&nbsp;"Add +" next to those you wish to invite.
          </p>
        </div>

        {content}
      </div>
    )

  }

  ContactContent(contacts) {
    return (
      <div>
        {this.SearchBar()}
        {this.ContactList(contacts)}
      </div>
    )
  }

  SearchBar() {
    return (
      <TextField
        id="contact-search-text"
        name="contactSearchText"
        label="Search by Name"
        margin="dense"
        variant="outlined"
        fullWidth
        onChange={this.searchFormChangeHandler}
        style={{marginBottom: "40px"}}
      />
    )
  }

  ContactList(contacts) {
    const contactItems = contacts.map((item, i) => {
      return (
        <Contact
          key={i}
          device={this.props.device}
          version={this.props.version}
          aid={this.props.aid}
          sessionId={this.props.sessionId}
          contact={item}
          sendPhoneInvite={this.props.sendPhoneInvite}
          sendInternalInvite={this.props.sendInternalInvite}
          sendExternalInvite={this.props.sendExternalInvite}
        />
      )
    })
    return (<ul className="contacts-list">{contactItems}</ul>)
  }

  Message(text) {
    return (
      <p className={"text-center"} style={{marginTop: "40px"}}>
        {text}
      </p>
    )
  }

}

export default Contacts



// WEBPACK FOOTER //
// ./src/Components/Contacts.js